import React, { useEffect, useState } from 'react';
import { string, oneOf } from 'prop-types';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { useDispatch, useSelector } from 'react-redux';
import i18next from 'i18next';

import StoreActions from '~redux/Stores/actions';

const INVERT_VALUE_KEYS = ['enabledManualDelivery'];

function SwitchAuto({ variant, customLabel }) {
  const dispatch = useDispatch();
  const storeSelected = useSelector((state) => state.core.storeSelected);
  const updatingStore = useSelector((state) => state.stores.updateStoreLoading);
  const isStoreLoading = useSelector((state) => state.stores.storeByIdLoading);

  const variantValue = useSelector((state) => Boolean(state?.stores?.storeById?.[variant]));

  const [isEnabled, setEnabled] = useState(variantValue);
  const onPostFailure = () => setEnabled(!isEnabled);
  const onPostSuccess = () => dispatch(StoreActions.getStoreById(storeSelected));

  useEffect(() => {
    setEnabled(variantValue);
  }, [variantValue]);

  const onChange = (event) => {
    setEnabled(event.target.checked);
    const shouldInvertValue = INVERT_VALUE_KEYS.includes(variant);

    const data = {
      store: {
        id: storeSelected,
        [variant]: shouldInvertValue ? !event.target.checked : event.target.checked
      }
    };
    dispatch(StoreActions.updateStore(data, onPostSuccess, onPostFailure));
  };

  return (
    <div>
      <FormControlLabel
        control={
          <Switch checked={isEnabled} onChange={onChange} disabled={isStoreLoading || updatingStore} />
        }
        label={i18next.t(customLabel ? customLabel : `Orders:${variant}`)}
      />
    </div>
  );
}

SwitchAuto.propTypes = {
  customLabel: string,
  variant: oneOf(['autoAcceptOrder', 'enabledManualDelivery', 'autoReassignDelivery'])
};

export { SwitchAuto };
